var map = {
	"../pages/detail/detail.module": [
		797,
		4
	],
	"../pages/grid-box/grid-box.module": [
		798,
		3
	],
	"../pages/home/home.module": [
		800,
		2
	],
	"../pages/login/login.module": [
		799,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 229;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 229
// module chunks = 5